export default "__VITE_ASSET__D6ssf2mC__"